jQuery(document).ready(function(){



jQuery('.go-back a').click(function() {
javascript:history.back();
return false;
});

style = 'easeOutQuart';
jQuery('#product-collection li').hover(  
function() {  
//show
jQuery(this).children('div:first').stop(false,true).animate({bottom:1,left:1},{duration:500, easing: style});  
},  
   
function() {  
//hide
jQuery(this).children('div:first').stop(false,true).animate({bottom:-70, left:-191},{duration:500, easing: style});  
}  
);

jQuery('#search-input').click(function() {
jQuery(this).val('');
});

	jQuery('#sidebar-accordion').accordion({
	header: 'h3',
	selectedClass: 'selected',
	navigation: true,
	autoHeight: false,
	active: '.selected',
animated: 'bounceslide',
	alwaysOpen: false
	});


	jQuery("#sidebar-accordion ul.animated a").hover(function(){
		jQuery(this).stop().animate({ paddingLeft: "0px" }, 'fast');
	}, function(){
		jQuery(this).stop().animate({ paddingLeft: "0px" }, 'fast');
	});



});